(function () {
  function initWedcharmMobileMenu() {
    const drawer = document.querySelector('[data-wc-mobile-menu]');
    const openButtons = document.querySelectorAll(
      '[data-wc-mobile-menu-open], [data-menu-toggle], [aria-controls="WedcharmMobileMenu"]'
    );
    const closeButtons = document.querySelectorAll('[data-wc-mobile-menu-close]');

    if (!drawer || drawer.dataset.wcMobileMenuReady === 'true') {
      return;
    }

    drawer.dataset.wcMobileMenuReady = 'true';

    const panel = drawer.querySelector('.wc-mobile-menu__panel');

    function setOpenButtonState(isOpen) {
      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function openMenu() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('wc-mobile-menu-open');
      setOpenButtonState(true);

      window.setTimeout(() => {
        if (panel) {
          panel.focus({ preventScroll: true });
        }
      }, 40);
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('wc-mobile-menu-open');
      setOpenButtonState(false);
    }

function openContactChat(fallbackUrl) {
  const chatToggle = document.querySelector(
    '[data-wc-contact-chat-toggle], [data-wc-chat-toggle], [data-wc-contact-toggle], .wc-contact-chat__toggle, .wc-contact-chat__toggle--icon'
  );

  if (document.body && document.body.classList.contains('template-index')) {
    document.body.classList.add('wc-home-chat-requested');
    document.body.classList.remove('wc-home-mobile-menu-active');
  }

  closeMenu();

  window.setTimeout(() => {
    if (chatToggle) {
      chatToggle.click();
      return;
    }

    if (fallbackUrl && fallbackUrl !== '#') {
      window.location.href = fallbackUrl;
    }
  }, 260);
}

    openButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        if (drawer.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeMenu();
      });
    });

    drawer.addEventListener('click', (event) => {
      const stylistButton = event.target.closest('[data-wc-mobile-menu-chat]');

      if (stylistButton) {
        event.preventDefault();
        openContactChat(stylistButton.dataset.whatsappUrl || '#');
        return;
      }

      const link = event.target.closest('a');

      if (!link) {
        return;
      }

      closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });

    drawer.querySelectorAll('.wc-mobile-menu__details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) {
          return;
        }

        drawer.querySelectorAll('.wc-mobile-menu__details').forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWedcharmMobileMenu);
  } else {
    initWedcharmMobileMenu();
  }

  document.addEventListener('shopify:section:load', initWedcharmMobileMenu);
})();